module.exports = __webpack_public_path__ + "img/11.0577533c.png";